__turbopack_context__.v({
  "address": "styles-module__TFsFFG__address",
  "archiveButton": "styles-module__TFsFFG__archiveButton",
  "badge": "styles-module__TFsFFG__badge",
  "blockHead": "styles-module__TFsFFG__blockHead",
  "deleteButton": "styles-module__TFsFFG__deleteButton",
  "description": "styles-module__TFsFFG__description",
  "editButton": "styles-module__TFsFFG__editButton",
  "icon": "styles-module__TFsFFG__icon",
  "iconButtonsContainer": "styles-module__TFsFFG__iconButtonsContainer",
  "morePhotosOverlay": "styles-module__TFsFFG__morePhotosOverlay",
  "price": "styles-module__TFsFFG__price",
  "profileObjectItem": "styles-module__TFsFFG__profileObjectItem",
  "profileObjectItemAction": "styles-module__TFsFFG__profileObjectItemAction",
  "profileObjectItemContent": "styles-module__TFsFFG__profileObjectItemContent",
  "profileObjectItemCounter": "styles-module__TFsFFG__profileObjectItemCounter",
  "profileObjectItemDD": "styles-module__TFsFFG__profileObjectItemDD",
  "profileObjectItemFooter": "styles-module__TFsFFG__profileObjectItemFooter",
  "profileObjectItemImage": "styles-module__TFsFFG__profileObjectItemImage",
  "rm": "styles-module__TFsFFG__rm",
  "thumbnailWrapper": "styles-module__TFsFFG__thumbnailWrapper",
  "title": "styles-module__TFsFFG__title",
});
